var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "fu-table",
        { attrs: { data: _vm.tableData } },
        [
          _c("el-table-column", { attrs: { type: "selection" } }),
          _c("el-table-column", {
            attrs: { prop: "date", label: "日期", "min-width": "180" }
          }),
          _c("el-table-column", {
            attrs: { prop: "name", label: "姓名", "min-width": "180", fix: "" }
          }),
          _c("el-table-column", {
            attrs: { prop: "address", label: "地址", show: false }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("fu-table-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              total: _vm.total
            },
            on: {
              "update:currentPage": function($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function($event) {
                _vm.currentPage = $event
              },
              "update:pageSize": function($event) {
                _vm.pageSize = $event
              },
              "update:page-size": function($event) {
                _vm.pageSize = $event
              },
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }